'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/number/monthAgo.js